import { useMutation } from "@tanstack/react-query";
import { post } from "../../../api/util";
import { useState } from "react";
import { FirmaDto, PersonDto } from "../../../interfaces/schema";
import { AutoCompleteItem } from "../../autocomplete/interface";
import { AutoCompleteFirmaResponse } from "../../autocomplete/AutoCompleteFirma";

export interface FirmaMasseFlytDTO {
  nyFirmaId: string;
  flytteDato: string;
}

export interface MasseFlyttetFirmaDTO {
  fejl: {
    person: PersonDto;
    fejlBesked: string;
  }[];
  firma: FirmaDto;
  personRelationer: PersonFirmaDTO[];
}

export default function useFirmaMasseFlyt(firmaId: string) {
  const [step, setStep] = useState<1 | 2 | 3>(1);
  const [nytFirma, setNytFirma] = useState<
    AutoCompleteItem<AutoCompleteFirmaResponse> | null | undefined
  >(undefined);
  const [flytteDato, setFlytteDato] = useState<Date | null>(null);
  const dryRunMutation = useMutation({
    mutationFn: (dto: FirmaMasseFlytDTO) => {
      return post<MasseFlyttetFirmaDTO>({
        query: `firma/${firmaId}/wizards/masseflyt`,
        body: {
          ...dto,
          gemData: false,
        },
      });
    },
    onSuccess: () => {
      setStep(2);
    },
    onError: () => {
      setTimeout(() => {
        dryRunMutation.reset();
      }, 3000);
    },
  });
  const mutation = useMutation({
    mutationFn: (dto: FirmaMasseFlytDTO) => {
      return post<MasseFlyttetFirmaDTO>({
        query: `firma/${firmaId}/wizards/masseflyt`,
        body: {
          ...dto,
          gemData: true,
        },
      });
    },
    onSuccess: () => {
      setStep(3);
    },
    onError: () => {
      setTimeout(() => {
        mutation.reset();
      }, 3000);
    },
  });

  return {
    dryRunMutation,
    mutation,
    step,
    setStep,
    nytFirma,
    setNytFirma,
    flytteDato,
    setFlytteDato,
  };
}
